import sectionTableBenefitsComparisonCss from '../css-snippets/section-table-benefits-comparison';

const html = `
<style>${sectionTableBenefitsComparisonCss}</style>
<div class="wrapper-container" id="wrapper-container-unique-id" data-id="unique-id" data-attribute="wrapper-container"
  data-background-color="#EAFDD7"
  data-enable-background-image="false" data-background-img="" data-top-padding="true" data-bottom-padding="true"
  data-table-header-color="" data-table-odd-row-color="" data-header-border-enabled="false">
  <div style="background-color: #eafdd7;" data-attribute="wrapper-content" data-center-y="true" class="wrapper-content container">
    <div data-attribute="title-content" class="title-content">
      <h2 style="text-align: center">
        Why Choose Our Therapy Toy for Autistic Communication
      </h2>
    </div>
    <div data-attribute="table-benefits-comparison" class="wrap-table">
      <figure class="table" style="width: 100%">
        <table class="ck-table-resized">
          <colgroup>
            <col style="width: 20%" />
            <col style="width: 30%" />
            <col style="width: 25%" />
            <col style="width: 25%" />
          </colgroup>
          <thead>
            <tr>
              <th style="height: 60px; padding: 12px; text-align: left">
                <p style="text-align: justify">
                  <span style="color: #000000">
                    <strong>Features</strong>
                  </span>
                </p>
              </th>
              <th style="background-color: #90cf5b; height: 60px; padding: 12px">
                <p style="text-align: center">
                  <span style="color: #000000">
                    <strong>LED Glowing Lizard</strong>
                  </span>
                </p>
              </th>
              <th style="height: 60px; padding: 12px">
                <p style="text-align: center">
                  <span style="color: #000000">
                    <strong>Ordinary Electric Toys</strong>
                  </span>
                </p>
              </th>
              <th style="height: 60px; padding: 12px">
                <p style="text-align: center">
                  <span style="color: #000000">
                    <strong>Traditional Pet Toys</strong>
                  </span>
                </p>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="background-color: inherit; height: auto; padding: 12px">
                <p style="text-align: left">
                  <strong>Interactive Fun</strong>
                </p>
              </td>
              <td style="background-color: #90cf5b; height: auto; padding: 12px">
                <p style="text-align: center">
                  <span contenteditable="false"><img
                      src="https://cdn.skyfastimg.com/images/2025/12/23/image-694a133a6b02527577d98b13.png?q=80" />
                  </span>
                </p>
                <p style="text-align: center">
                  Realistic crawling & auto-steering for kids AND pets
                </p>
              </td>
              <td style="background-color: inherit; height: auto; padding: 12px">
                <p style="text-align: center">
                  <span contenteditable="false"><img
                      src="https://cdn.skyfastimg.com/images/2025/12/23/image-694a132c08283c9f0530f871.png?q=80" />
                  </span>
                </p>
                <p style="text-align: center">
                  Predictable paths, quick to bore
                </p>
              </td>
              <td style="background-color: inherit; height: auto; padding: 12px">
                <p style="text-align: center">
                  <span contenteditable="false"><img
                      src="https://cdn.skyfastimg.com/images/2025/12/23/image-694a132c08283c9f0530f871.png?q=80" />
                  </span>
                </p>
                <p style="text-align: center">
                  Static or simple movement, low engagement
                </p>
              </td>
            </tr>
            <tr>
              <td style="background-color: inherit; height: auto; padding: 12px">
                <p style="text-align: left">
                  <strong> Target Audience </strong>
                </p>
              </td>
              <td style="background-color: #90cf5b; height: auto; padding: 12px">
                <p style="text-align: center">
                  <span contenteditable="false"><img
                      src="https://cdn.skyfastimg.com/images/2025/12/23/image-694a133a6b02527577d98b13.png?q=80" />
                  </span>
                </p>
                <p style="text-align: center">
                  Designed for both kids (6+) and pets
                </p>
              </td>
              <td style="background-color: inherit; height: auto; padding: 12px">
                <p style="text-align: center">
                  <span contenteditable="false"><img
                      src="https://cdn.skyfastimg.com/images/2025/12/23/image-694a132c08283c9f0530f871.png?q=80" />
                  </span>
                </p>
                <p style="text-align: center">Usually for kids OR pets only</p>
              </td>
              <td style="background-color: inherit; height: auto; padding: 12px">
                <p style="text-align: center">
                  <span contenteditable="false"><img
                      src="https://cdn.skyfastimg.com/images/2025/12/23/image-694a132c08283c9f0530f871.png?q=80" />
                  </span>
                </p>
                <p style="text-align: center">
                  Designed only for pets, kids ignore them
                </p>
              </td>
            </tr>
            <tr>
              <td style="background-color: inherit; height: auto; padding: 12px">
                <p style="text-align: left">
                  <strong> Visual Appeal </strong>
                </p>
              </td>
              <td style="background-color: #90cf5b; height: auto; padding: 12px">
                <p style="text-align: center">
                  <span contenteditable="false"><img
                      src="https://cdn.skyfastimg.com/images/2025/12/23/image-694a133a6b02527577d98b13.png?q=80" />
                  </span>
                </p>
                <p style="text-align: center">
                  LED glowing eyes for thrilling dark play
                </p>
              </td>
              <td style="background-color: inherit; height: auto; padding: 12px">
                <p style="text-align: center">
                  <span contenteditable="false"><img
                      src="https://cdn.skyfastimg.com/images/2025/12/23/image-694a132c08283c9f0530f871.png?q=80" />
                  </span>
                </p>
                <p style="text-align: center">No special lighting effects</p>
              </td>
              <td style="background-color: inherit; height: auto; padding: 12px">
                <p style="text-align: center">
                  <span contenteditable="false"><img
                      src="https://cdn.skyfastimg.com/images/2025/12/23/image-694a132c08283c9f0530f871.png?q=80" />
                  </span>
                </p>
                <p style="text-align: center">
                  No light-up features, less captivating
                </p>
              </td>
            </tr>
            <tr>
              <td style="background-color: inherit; height: auto; padding: 12px">
                <p style="text-align: left">
                  <strong> Durability & Safety </strong>
                </p>
              </td>
              <td style="background-color: #90cf5b; height: auto; padding: 12px">
                <p style="text-align: center">
                  <span contenteditable="false"><img
                      src="https://cdn.skyfastimg.com/images/2025/12/23/image-694a133a6b02527577d98b13.png?q=80" />
                  </span>
                </p>
                <p style="text-align: center">
                  ABS material, shockproof, smooth edges
                </p>
              </td>
              <td style="background-color: inherit; height: auto; padding: 12px">
                <p style="text-align: center">
                  <span contenteditable="false"><img
                      src="https://cdn.skyfastimg.com/images/2025/12/23/image-694a132c08283c9f0530f871.png?q=80" />
                  </span>
                </p>
                <p style="text-align: center">
                  Cheap plastic, breaks easily, sharp
                </p>
              </td>
              <td style="background-color: inherit; height: auto; padding: 12px">
                <p style="text-align: center">
                  <span contenteditable="false"><img
                      src="https://cdn.skyfastimg.com/images/2025/12/23/image-694a132c08283c9f0530f871.png?q=80" />
                  </span>
                </p>
                <p style="text-align: center">
                  Easily destroyed by pets, potential hazard
                </p>
              </td>
            </tr>
            <tr>
              <td style="background-color: inherit; height: auto; padding: 12px">
                <p style="text-align: left">
                  <strong> Value </strong>
                </p>
              </td>
              <td style="background-color: #90cf5b; height: auto; padding: 12px">
                <p style="text-align: center">
                  <span contenteditable="false"><img
                      src="https://cdn.skyfastimg.com/images/2025/12/23/image-694a133a6b02527577d98b13.png?q=80" />
                  </span>
                </p>
                <p style="text-align: center">
                  Dual-use, high cost-performance
                </p>
              </td>
              <td style="background-color: inherit; height: auto; padding: 12px">
                <p style="text-align: center">
                  <span contenteditable="false"><img
                      src="https://cdn.skyfastimg.com/images/2025/12/23/image-694a132c08283c9f0530f871.png?q=80" />
                  </span>
                </p>
                <p style="text-align: center">
                  Similar price for single-use fun
                </p>
              </td>
              <td style="background-color: inherit; height: auto; padding: 12px">
                <p style="text-align: center">
                  <span contenteditable="false"><img
                      src="https://cdn.skyfastimg.com/images/2025/12/23/image-694a132c08283c9f0530f871.png?q=80" />
                  </span>
                </p>
                <p style="text-align: center">
                  Need constant replacement, high long-term cost
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </figure>
    </div>
  </div>
</div>
`;
export default html;
